export enum PerformanceIndicator {
  blue = "Blue",
  yellow = "Yellow",
  red = "Red",
  grey = "Grey",
}
